module.exports = __webpack_public_path__ + "img/2024-12-12b_2.d1a94a12.jpg";